import { DataLoader } from '../components/ui/DataLoader';
import { useDashboardData } from '../hooks/react-query/useDashboard';
import { useAuth } from '@/hooks/useAuthHook';
import {
  VIEW_PENDING_TASKS_INVESTORS,
  VIEW_PENDING_TASKS_PORTFOLIO,
} from '@/constants/permissions';
import {
  DashboardHeader,
  PendingTasksCard,
  RecentActivityCard,
} from '../components/dashboard';

// Loading skeleton component that matches the current dashboard layout
function DashboardSkeleton() {
  return (
    <div className="space-y-6">
      {/* Recent Activity Skeleton */}
      <div className="animate-pulse">
        <div className="h-8 bg-muted rounded w-1/3 mb-2" />
        <div className="h-4 bg-muted rounded w-1/2 mb-4" />
        <div className="space-y-4">
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex items-center space-x-4">
              <div className="w-10 h-10 bg-muted rounded-full" />
              <div className="flex-1 space-y-2">
                <div className="h-4 bg-muted rounded w-3/4" />
                <div className="h-3 bg-muted rounded w-1/2" />
              </div>
              <div className="h-4 bg-muted rounded w-20" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function DashboardPage() {
  // Use React Query to fetch dashboard data with separate endpoints
  const { recentActivity, isLoading, error, refetch } = useDashboardData();
  const { hasPermission } = useAuth();

  // The pending tasks feed is permission-gated server-side; only mount the card
  // for users who can see at least one task category, mirroring the backend gate.
  const canViewPendingTasks =
    hasPermission(VIEW_PENDING_TASKS_INVESTORS) ||
    hasPermission(VIEW_PENDING_TASKS_PORTFOLIO);

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <DashboardHeader />

      {/* Pending Tasks - self-contained, owns its own query independent of dashboard data */}
      {canViewPendingTasks && <PendingTasksCard />}

      <DataLoader
        data={{ recentActivity }}
        isLoading={isLoading}
        error={error}
        refetch={refetch}
        loadingComponent={<DashboardSkeleton />}
      >
        {() => {
          const safeRecentActivity = recentActivity || [];

          return (
            <div className="space-y-6">
              {/* Main Content */}
              <RecentActivityCard activities={safeRecentActivity} />
            </div>
          );
        }}
      </DataLoader>
    </div>
  );
}
